export default __webpack_public_path__ + "static/media/testifyThree.05bab6f2.png";